export const config = {
  rowSelectionType: 'radio',
  fieldControl: false,
  columns: [
    {
      title: '员工姓名',
      key: 'userName',
      dataIndex: 'userName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '员工电话',
      key: 'userPhone',
      dataIndex: 'userPhone',
      width: 120,
    },
    {
      title: '所属组织',
      key: 'org',
      dataIndex: 'orgNamePath',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '职位',
      key: 'roleName',
      dataIndex: 'roleName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
  ],
  search: [
    {
      name: 'userNameKeyword',
      label: '员工姓名',
    },
  ],
}
